import { canView } from '@addictivegroup/addictive-docview'

/**
 * What a file can be shown as in the panel (D-223), by its type and, where the type says little
 * (files from Dynamics often come as application/octet-stream), by its name:
 * image, video, audio, pdf, text (read as it is), office (Word, Excel, PowerPoint and CSV, drawn
 * by addictive-docview from the file itself), or null — downloaded.
 */
const EXT = {
  pdf: 'pdf',
  png: 'image', jpg: 'image', jpeg: 'image', gif: 'image', webp: 'image', bmp: 'image', svg: 'image', avif: 'image',
  mp4: 'video', webm: 'video', mov: 'video', m4v: 'video',
  mp3: 'audio', m4a: 'audio', wav: 'audio', ogg: 'audio', oga: 'audio', opus: 'audio', aac: 'audio',
  txt: 'text', log: 'text', md: 'text', json: 'text', xml: 'text', ini: 'text', yaml: 'text', yml: 'text',
}
const TEXT_TYPES = ['application/json', 'application/xml', 'text/plain', 'text/markdown', 'text/xml', 'text/x-log']

export const extensionOf = (name = '') => (String(name).match(/\.([a-z0-9]+)$/i)?.[1] || '').toLowerCase()

export function previewKind({ mime = '', name = '' } = {}) {
  const type = String(mime || '').toLowerCase().split(';')[0].trim()
  const ext = extensionOf(name)
  if (type === 'application/pdf') return 'pdf'
  // HEIC/TIFF: most browsers show neither.
  if (type.startsWith('image/') && !/heic|heif|tiff/.test(type)) return 'image'
  if (type.startsWith('video/') || type === 'application/mp4') return 'video'
  if (type.startsWith('audio/')) return 'audio'
  if (canView({ mime: type, name })) return 'office'
  if (TEXT_TYPES.includes(type)) return 'text'
  return EXT[ext] || null
}

/** Text larger than this is not shown whole: the start of it, and the file to download. */
export const TEXT_LIMIT = 512 * 1024

/** Bytes as text: UTF-8, else Windows-1250 (Polish files written on Windows). */
export function decodeText(buffer) {
  const bytes = new Uint8Array(buffer)
  try {
    return new TextDecoder('utf-8', { fatal: true }).decode(bytes).replace(/^\uFEFF/, '')
  } catch {
    return new TextDecoder('windows-1250').decode(bytes)
  }
}
